import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addSession,
  deleteSession,
  listenSessions,
  updateSession,
} from "../../services/sessionChargeService";
import { DataFinalArray, FinalDataBmwRow, MonthlySummary, SessionDeCharge } from "../../types/BMW";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Container,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Timestamp } from "firebase/firestore";
import ConsumptionChart from "../../component/charts/ConsumptionChart";

import { writeBatch, collection, doc } from "firebase/firestore";
import { db } from "../../firebase"; // adapte le chemin si besoin
import EstimationPleinChart from "../../component/charts/EstimationPleinChart";
import { Padding } from "@mui/icons-material";

const importHistoricalData = async () => {
  const rawData = [
    ["28/9/2025", 57544, 55, 250, 0],
    ["28/9/2025", 57659, 64, 280, 13.41],
    ["28/9/2025", 57730, 71, 309, 6.76],
    ["1/10/2025", 57764, 67, 262, 1.75],
    ["3/10/2025", 57798, 63, 254, 1.4],
    ["5/10/2025", 57850, 80, 385, 9.45],
    ["11/10/2025", 58043, 85, 384, 5.25],
    ["12/10/2025", 58111, 78, 408, 3.5],
    ["15/10/2025", 58152, 81, 372, 3.4],
    ["17/10/2025", 58216, 81, 406, 4.2],
    ["22/10/2025", 58329, 66, 256, 2.52],
    ["25/10/2025", 58364, 64, 263, 1.85],
    ["29/10/2025", 58445, 52, 229, 1.46],
    ["31/10/2025", 58527, 37, 177, 1.4],
    ["2/11/2025", 58559, 60, 257, 6.3],
    ["5/11/2025", 58618, 53, 225, 2.3],
    ["8/11/2025", 58650, 66, 267, 4.75],
    ["10/11/2025", 58689, 80, 306, 5],
    ["12/11/2025", 58707, 87, 364, 2.41],
    ["19/11/2025", 58806, 71, 289, 2.75],
    ["28/11/2025", 58954, 83, 265, 11],
    ["30/11/2025", 58996, 80, 347, 2.8],
    ["3/12/2025", 59043, 77, 296, 2.83],
    ["10/12/2025", 59122, 67, 273, 2.59],
    ["13/12/2025", 59191, 63, 222, 4.9],
    ["14/12/2025", 59256, 68, 292, 5.95],
    ["14/12/2025", 59268, 77, 317, 3.85],
    ["18/12/2025", 59345, 89, 371, 9.96],
    ["23/12/2025", 59417, 80, 295, 3.22],
    ["27/12/2025", 59448, 82, 295, 2.8],
    ["28/12/2025", 59471, 88, 324, 3.5],
    ["30/12/2025", 59503, 80, 264, 0.75],
    ["30/12/2025", 59505, 82, 255, 0],
    ["3/1/2026", 59544, 73, 246, 2.1],
    ["7/1/2026", 59596, 62, 207, 2.92],
    ["14/1/2026", 59678, 50, 202, 3],
    ["23/1/2026", 59819, 83, 269, 12.67],
    ["26/1/2026", 59893, 87, 345, 5.52],
    ["17/2/2026", 60216, 78, 311, 5.91],
  ];

  const batch = writeBatch(db);
  const colRef = collection(db, "sessionsDeCharge");
  // Convertit "28/9/2024" ou "28/9/2024 18:07" en Date JS
  function parseFrenchDate(dateStr: string): Date {
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);

    let hours = 0;
    let minutes = 0;

    if (timePart) {
      [hours, minutes] = timePart.split(":").map(Number);
    }

    return new Date(year, month - 1, day, hours, minutes);
  }

  rawData.forEach(
    ([dateStr, kmsTotal, pourcentageCharge, autonomie, montant]) => {
      const date = parseFrenchDate(dateStr as any);
      const newDoc = doc(colRef);

      batch.set(newDoc, {
        date: Timestamp.fromDate(date),
        kmsTotal,
        pourcentageCharge,
        autonomie,
        montant,
        borne: "", // vide pour compléter plus tard
      });
    },
  );

  await batch.commit();
  alert("Import terminé 🚀");
};;
export const MAIL_SERVER = process.env.REACT_APP_MAIL_SERVER;
export const MAIL_ROUTE = process.env.REACT_APP_MAIL_ROUTE;
type SessionForm = Omit<SessionDeCharge, "id" | "date"> & {
  date: Date; // date JS pour le formulaire
};


function FormulaireBmw() {
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState<string | null>(null);

  const toastId = useRef<any>();
    const [sessions, setSessions] = useState<SessionDeCharge[]>([]);
    
    const [finalWithMontsData, setFinalWithMontsData] = useState<
      FinalDataBmwRow[]
    >([]);
    const [finalData, setFinalData] = useState<DataFinalArray[]>([]);

useEffect(() => {
  if (!sessions.length) return;

  const sorted = [...sessions].sort(
    (a, b) => (a.kmsTotal ?? 0) - (b.kmsTotal ?? 0),
  );

  let previousKms = 0;
  let sommeEuro = 0;
  let sommeKms = 0;

  const computed: DataFinalArray[] = [];
  const monthlyMap: Record<
    string,
    {
      euros: number;
      firstKms: number;
      lastKms: number;
    }
  > = {};

  sorted.forEach((s, index) => {
    const kmsTotal = s.kmsTotal ?? 0;
    const montant = s.montant ?? 0;
    const date = s?.date?.toDate();

    const monthKey = `${date.getFullYear()}-${date.getMonth()}`;

    const kmsParcourus = index === 0 ? 0 : kmsTotal - previousKms;

    sommeEuro += montant;
    sommeKms += kmsParcourus;

    const conso = sommeKms > 0 ? (sommeEuro / sommeKms) * 100 : 0;

    const pleinEstimation =
      s.pourcentageCharge && s.autonomie
        ? (s.autonomie / s.pourcentageCharge) * 100
        : 0;

    // 🔥 Gestion mensuelle
    if (!monthlyMap[monthKey]) {
      monthlyMap[monthKey] = {
        euros: 0,
        firstKms: kmsTotal,
        lastKms: kmsTotal,
      };
    }

    monthlyMap[monthKey].euros += montant;
    monthlyMap[monthKey].lastKms = kmsTotal;

    computed.push({
      id: s.id,
      date: s.date,
      montant,
      borne: s.borne,
      kmsTotal,
      pourcentageCharge: s.pourcentageCharge,
      autonomie: s.autonomie,
      kmsParcourus,
      sommeEuro,
      sommeKms,
      conso,
      pleinEstimation,
    });

    previousKms = kmsTotal;
  });

  // 🔥 Injecter les lignes mensuelles
  const finalWithMonths: FinalDataBmwRow[] = [];
  const finalWithoutMonths: DataFinalArray[] = [];

  computed.forEach((row) => {
    const date = row?.date?.toDate();
    const key = `${date.getFullYear()}-${date.getMonth()}`;

    finalWithMonths.push(row);
    finalWithoutMonths.push(row);

    const nextRow = computed[computed.indexOf(row) + 1];
    const nextMonth =
      nextRow &&
      `${nextRow?.date?.toDate().getFullYear()}-${nextRow.date
        ?.toDate()
        .getMonth()}`;

    if (key !== nextMonth) {
      const monthData = monthlyMap[key];
      const kmsMois = monthData.lastKms - monthData.firstKms;

      const consoMois = kmsMois > 0 ? (monthData.euros / kmsMois) * 100 : 0;

      finalWithMonths.push({
        isMonthly: true,
        month: date.toLocaleDateString("fr-FR", {
          month: "long",
          year: "numeric",
        }),
        consoMois,
        kmsMois,
        somme: monthData.euros
      });
    }
  });

    setFinalWithMontsData(finalWithMonths);
    setFinalData(finalWithoutMonths);
    console.log('finalWithMonths', finalWithMonths)
}, [sessions]);
    

  const [form, setForm] = useState<SessionForm>({
    date: new Date(), // date par défaut
    montant: undefined, // laisser vide
    borne: "", // chaîne vide
    kmsTotal: undefined,
    pourcentageCharge: undefined,
    autonomie: undefined,
  });

  /* =========================
     📝 Gestion du formulaire
  ========================= */
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "borne" ? value : Number(value),
    }));
  };
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({
      ...prev,
      date: new Date(e.target.value),
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (editingId) {
      await updateSession(editingId, {
        ...form,
        date: Timestamp.fromDate(form.date),
      });
      setEditingId(null);
    } else {
      await addSession({
        ...form,
        date: Timestamp.fromDate(form.date),
        montant: Number(form.montant),
      });
    }

    setOpen(false);
  };
  /* =========================
     👀 Écoute Firestore temps réel
  ========================= */
  useEffect(() => {
    const unsubscribe = listenSessions(setSessions);
    return () => unsubscribe();
  }, []);

  const Toast = (message: string, type: number) => {
    switch (type) {
      case 1:
        toastId.current = toast(message, {
          autoClose: false,
          type: toast.TYPE.INFO,
          theme: "dark",
        });
        break;
      case 2:
        toast.update(toastId?.current, {
          render: message,
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
          position: "top-right",
          hideProgressBar: false, //cacher  la barre de progression
          closeOnClick: true, //cache au click
          pauseOnHover: true, //pause hover
          draggable: false, //on peut pas la faire glisser
          progress: undefined,
          theme: "dark",
          bodyClassName: "toastify-color",
        });
        break;
      case 3:
        toast.update(toastId.current, {
          render: message,
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          position: "top-right",
          hideProgressBar: false, //cacher  la barre de progression
          closeOnClick: true, //cache au click
          pauseOnHover: true, //pause hover
          draggable: false, //on peut pas la faire glisser
          progress: undefined,
          theme: "dark",
          bodyClassName: "toastify-color",
        });
        break;
      case 4:
        toast(message, {
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          position: "top-right",

          theme: "dark",
          bodyClassName: "toastify-color",
        });
        break;

      default:
        break;
    }
  };
  const handleDelete = async (id: string) => {
    if (window.confirm("Supprimer cette session ?")) {
      await deleteSession(id);
    }
  };

  const handleEdit = (session: SessionDeCharge) => {
    setEditingId(session.id!);

    setForm({
      borne: session.borne,
      montant: session.montant,
      kmsTotal: session.kmsTotal,
      pourcentageCharge: session.pourcentageCharge,
      autonomie: session.autonomie,
      date: session?.date?.toDate(),
    });

    setOpen(true);
    };

  return (
    <div className="bmwZone">
      <div className="bmw_form">
        <div className="contact_message_titre">
          <Button variant="outlined" onClick={() => setOpen(true)}>
            Ajouter
          </Button>
          {/* <Button
            variant="contained"
            color="secondary"
            onClick={importHistoricalData}
            sx={{ mb: 3 }}
          >
            Importer historique
          </Button> */}
          <>
            <Dialog
              open={open}
              onClose={() => setOpen(false)}
              fullWidth
              maxWidth="xs"
            >
              <>
                <form id="contact" onSubmit={handleSubmit}>
                  <DialogTitle>
                    {editingId ? "Modifier la session" : "Ajouter une session"}
                  </DialogTitle>
                  <DialogContent>
                    {/* <h3 className="main_message_salut">Ajouter une session de charge</h3> */}

                    <span className="line_vertical">
                      <ul className="contact_ul">
                        <li className="fullFieldInPop">
                          <input
                            required
                            className="input_field"
                            type="text"
                            placeholder="Borne"
                            name="borne"
                            value={form.borne}
                            onChange={handleChange}
                          />
                        </li>

                        <li className="fullFieldInPop">
                          <input
                            required
                            className="input_field"
                            type="number"
                            step="0.01" // autorise les décimales
                            placeholder="Montant (€)"
                            name="montant"
                            value={form.montant ?? ""} // laisse vide si undefined
                            onChange={handleChange}
                          />
                        </li>

                        <li className="fullFieldInPop">
                          <input
                            required
                            className="input_field"
                            type="number"
                            placeholder="Kms total"
                            name="kmsTotal"
                            value={form.kmsTotal}
                            onChange={handleChange}
                          />
                        </li>

                        <li className="fullFieldInPop">
                          <input
                            required
                            className="input_field"
                            type="number"
                            placeholder="% Charge"
                            name="pourcentageCharge"
                            value={form.pourcentageCharge}
                            onChange={handleChange}
                          />
                        </li>

                        <li className="fullFieldInPop">
                          <input
                            required
                            className="input_field"
                            type="number"
                            placeholder="Autonomie"
                            name="autonomie"
                            value={form.autonomie}
                            onChange={handleChange}
                          />
                        </li>

                        <li className="fullFieldInPop">
                          <input
                            required
                            className="input_field"
                            type="date"
                            name="date"
                            value={form.date.toISOString().substring(0, 10)}
                            onChange={handleDateChange}
                          />
                        </li>

                        {/* <li>
                          <div className="aligne_button">
                            <div className="filled-button">
                              <button className="contact-button" type="submit">
                                <span className="bef"></span>
                                <span className="text">Envoyer le message</span>
                                <span className="pointSpan"> </span>
                                <br />
                              </button>
                              <div className="bord"></div>
                            </div>
                          </div>
                        </li> */}
                      </ul>
                    </span>
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={() => setOpen(false)}>Annuler</Button>
                    <Button type="submit" variant="contained">
                      Enregistrer
                    </Button>
                  </DialogActions>
                </form>
              </>
            </Dialog>
          </>
        </div>
      </div>
      {/* // extra-small * xs: 0, * // small * sm: 600, * // medium * md: 900, * //
      large * lg: 1200, * // extra-large * xl: 1536, */}
      <Container maxWidth="xl">
        <Typography variant="h5" gutterBottom>
          Sessions enregistrées
        </Typography>

        <Table component={Paper} size="small">
          <TableHead>
            <TableRow>
              <TableCell>€/100km</TableCell>
              {/* <TableCell>Somme km</TableCell> */}
              <TableCell>Date</TableCell>
              <TableCell>Somme (€)</TableCell>
              <TableCell>Somme (km)</TableCell>
              <TableCell>Montant (€)</TableCell>
              <TableCell>Kms Total</TableCell>
              <TableCell>% Charge</TableCell>
              <TableCell>Autonomie</TableCell>
              <TableCell>Parcourus</TableCell>
              <TableCell>Borne</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {finalWithMontsData.map((s: FinalDataBmwRow, index) => {
              if ("isMonthly" in s) {
                return (
                  <TableRow
                    key={`month-${index}`}
                    sx={{ backgroundColor: "#102027" }}
                  >
                    <TableCell sx={{ fontWeight: "bold", color: "#4fc3f7" }}>
                      {s.consoMois.toFixed(2)}
                    </TableCell>

                    <TableCell colSpan={2} sx={{ fontWeight: "bold" }}>
                      Résumé {s.month}
                    </TableCell>
                    <TableCell colSpan={1} sx={{ fontWeight: "bold" }}>
                      {s.kmsMois}
                    </TableCell>
                    <TableCell colSpan={7} sx={{ fontWeight: "bold" }}>
                      {s.somme?.toFixed(2)}
                    </TableCell>
                  </TableRow>
                );
              }

              return (
                <TableRow key={s.id}>
                  <TableCell>{s.conso?.toFixed(2)}</TableCell>

                  <TableCell>
                    {s.date?.toDate().toLocaleDateString("fr-FR", {
                      day: "2-digit",
                      month: "2-digit",
                    })}
                  </TableCell>

                  <TableCell>{s.sommeEuro?.toFixed(2)}</TableCell>
                  <TableCell>{s.sommeKms}</TableCell>
                  <TableCell>{s.montant}</TableCell>
                  <TableCell>{s.kmsTotal}</TableCell>
                  <TableCell>{s.pourcentageCharge}</TableCell>
                  <TableCell>{s.autonomie}</TableCell>
                  <TableCell>{s.kmsParcourus}</TableCell>
                  <TableCell>{s.borne}</TableCell>
                  <TableCell>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <IconButton size="small" onClick={() => handleEdit(s)}>
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleDelete(s.id!)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Container>
      <Container maxWidth="xl">
        <ConsumptionChart data={finalData} />
      </Container>
      <Container maxWidth="xl">
        <EstimationPleinChart data={finalData} />
      </Container>
      <ToastContainer />
    </div>
  );
}

export default FormulaireBmw;
